import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingExportFileSpecSearchCriteria extends ValueObject {

    public searchCriteria: string = "";

    public staticServiceProviderFileGroupingId: number | null = null;

    public staticExportFileSpecId: number | null = null;

    public serviceProviderGroupingName: string | null = null;

    public fileTypeConcatenated: string | null = null;
}